import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Download, Gift, Lock } from 'lucide-react';
export function OpeningLead() {
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) {
      cta.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleBuy = () => {
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Elegido en el Dolor',
        content_type: 'product',
        value: 6.36,
        currency: 'USD'
      });
    }
    window.open('https://www.simplementemejor.com/cart/51706800537880:1', '_blank');
  };
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="pt-12 pb-8 md:pb-16 px-4 md:px-6 w-full relative bg-[var(--bg-deep)] overflow-hidden" data-id="element-300">
      {/* Subtle background glow (not distracting) */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[60vh] pointer-events-none z-0" style={{
      background: 'radial-gradient(ellipse 60% 80% at 50% 0%, rgba(196,164,74,0.06) 0%, transparent 70%)'
    }} data-id="element-301" />

      <motion.div variants={container} initial="hidden" animate="show" className="max-w-[640px] mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-302">
        {/* Label */}
        <motion.div variants={item} data-id="element-303">
          <p className="text-[var(--accent)] font-bold tracking-widest uppercase text-xs md:text-sm mb-1.5 md:mb-3" data-id="element-304">
            🔥 Manual de Supervivencia Espiritual
          </p>
        </motion.div>

        {/* Headline */}
        <motion.div variants={item} data-id="element-305">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-[var(--text-heading)] leading-[1.1] mb-2 md:mb-4" data-id="element-306">
            Cuando Dios es lo Único que te Queda
          </h1>
        </motion.div>

        {/* Subtitle */}
        <motion.div variants={item} data-id="element-307">
          <p className="text-lg md:text-2xl text-[var(--accent)] font-serif italic mb-2 md:mb-4" data-id="element-308">
            Cómo Reconstruir tu Vida desde las Cenizas en 40 Días.
          </p>
        </motion.div>

        {/* Positioning */}
        <motion.div variants={item} data-id="element-309">
          <p className="text-sm md:text-base text-[var(--text-muted)] leading-relaxed max-w-xl mx-auto mb-6 md:mb-10" data-id="element-310">
            El manual de supervivencia espiritual para quienes han llegado al
            final de sus fuerzas y necesitan respuestas reales, no frases
            motivacionales.
          </p>
        </motion.div>

        {/* Book Image (3D Book Mockup) */}
        <motion.div variants={item} className="mb-6 md:mb-10 relative" style={{
        perspective: '800px'
      }} data-id="element-311">
          {/* The 3D book itself */}
          <motion.div animate={{
          y: [0, -10, 0],
          rotateY: [-2, 2, -2]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} style={{
          transformStyle: 'preserve-3d'
        }} className="relative z-10" data-id="element-312">
            <img src="https://cdn.magicpatterns.com/uploads/h5442if7pt1euWNdnTzczj/ChatGPT_Image_23_mar_2026,_06_35_12_p.m..png" alt="Método — Cuando Dios es lo único que te queda" className="w-44 md:w-72 mx-auto drop-shadow-[0_20px_50px_rgba(196,164,74,0.25)] rounded-lg" data-id="element-313" />
          </motion.div>
        </motion.div>

        {/* Price Display */}
        <motion.div variants={item} className="mb-3 md:mb-5 flex flex-col items-center" data-id="element-314">
          <div className="flex items-baseline justify-center gap-3" data-id="element-315">
            <span className="text-xl md:text-2xl text-[var(--text-muted)] line-through decoration-[var(--red-emphasis)]/60 opacity-70" data-id="element-316">
              $27.00
            </span>
            <span className="text-4xl md:text-5xl font-serif font-bold text-[var(--text-heading)]" data-id="element-317">
              $14.36
            </span>
          </div>
          <p className="text-[var(--accent)] text-xs font-bold uppercase tracking-widest mt-1" data-id="element-318">
            -47% OFF Hoy
          </p>
        </motion.div>

        {/* CTA Button */}
        <motion.div variants={item} className="w-full sm:w-auto mb-3 md:mb-4" data-id="element-319">
          <motion.button onClick={scrollToCTA} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full sm:w-auto px-6 md:px-10 py-3.5 md:py-4 bg-gradient-to-r from-[var(--accent)] to-[var(--accent-hover)] text-[#110608] font-extrabold text-sm md:text-lg rounded-xl shadow-[0_8px_25px_rgba(196,164,74,0.25)] flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-320">
            <Lock className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" data-id="element-321" />
            <span className="uppercase tracking-wide" data-id="element-322">
              SÍ, QUIERO EMPEZAR MI RECONSTRUCCIÓN
            </span>
          </motion.button>
        </motion.div>

        {/* Social Proof */}
        <motion.div variants={item} className="mb-3 md:mb-6" data-id="element-323">
          <div className="flex flex-col items-center gap-1.5" data-id="element-324">
            <div className="flex items-center gap-1" data-id="element-325">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[var(--accent)] text-[var(--accent)]" data-id="element-326" />)}
            </div>
            <p className="text-sm text-[var(--text-primary)] font-medium" data-id="element-327">
              +847 personas ya comenzaron su Día 1
            </p>
          </div>
        </motion.div>

        {/* Trust Badges */}
        <motion.div variants={item} data-id="element-328">
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 text-xs text-[var(--text-muted)]" data-id="element-329">
            <span className="flex items-center gap-1.5" data-id="element-330">
              <Download className="w-3.5 h-3.5 text-[var(--accent)]" data-id="element-331" />
              Acceso inmediato
            </span>
            <span className="hidden md:inline opacity-30" data-id="element-332">·</span>
            <span className="flex items-center gap-1.5" data-id="element-333">
              <Gift className="w-3.5 h-3.5 text-[var(--accent)]" data-id="element-334" />
              Acceso de por vida
            </span>
            <span className="hidden md:inline opacity-30" data-id="element-335">·</span>
            <span className="flex items-center gap-1.5" data-id="element-336">
              <ShieldCheck className="w-3.5 h-3.5 text-[var(--accent)]" data-id="element-337" />
              Garantía 7 días
            </span>
          </div>
        </motion.div>
      </motion.div>
    </section>;
}